<template>
    <Datepicker
        :format="dateFormat"
        v-model="model"
        :clearable="false"
        :month-picker="props.monthPicker"
        :auto-apply="props.autoApply"
        :utc="true"
        :class="{'is-invalid': !!error}"
        :enable-time-picker="props.enableTimePicker"
        :enable-minutes="props.enableMinutes"
        :enable-seconds="props.enableSeconds"
        :input-class-name="!!error ? 'form-control is-invalid' : 'form-control'"
        :ui="{input: !!error ? 'form-control is-invalid' : 'form-control'}"
        :max-date="props.maxDate"
        :min-date="props.minDate"
        :auto-position="props.autoPosition">
    </Datepicker>
    <span
        class="invalid-feedback"
        role="alert"
        v-if="error">
        {{ error }}
    </span>
</template>
<script setup lang="ts">
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

import {computed, onMounted, ref, toRef} from "vue";

const dateFormat = computed(() => {
    let format = "yyyy-MM-dd";
    
    if(props.monthPicker){
        format = "MM-yyyy";
    }

    if(props.enableTimePicker){
        if(props.enableSeconds){
            format = "yyyy-MM-dd HH:mm:ss";
        }
        else{
            format = "yyyy-MM-dd HH:mm";
        }
    }
    return format;
});

const model = defineModel();
defineOptions({
    inheritAttrs: false,
});
const props = defineProps({
    error: {
        type: String,
        default: null,
    },
    monthPicker: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    autoApply: {
        type: Boolean,
        default: true,
    },
    enableTimePicker: {
        type: Boolean,
        default: false,
    },
    enableMinutes: {
        type: Boolean,
        default: true,
    },
    enableSeconds: {
        type: Boolean,
        default: false,
    },
    maxDate: {
        type: Date,
        default: undefined
    },
    autoPosition: {
        type: Boolean,
        default: true,
    },
    minDate: {
        type: Date,
        default: undefined
    }
});
</script>
